import { ApolloError } from '@apollo/client';
import React from 'react';
import { EXPLORE_WEB_GetToursForToursSectionUnauthed as Data } from '../components/contentSections/toursSection/__generated__/EXPLORE_WEB_GetToursForToursSectionUnauthed';

type Value = {
  fetchTours: () => void;
  data?: Data;
  loading: boolean;
  error?: ApolloError;
};

export const ToursForToursSectionContext = React.createContext<Value>({
  fetchTours: () => Promise.resolve([]),
  loading: false,
});
